import type { FC } from 'react';
import { motion } from 'framer-motion';
import { t } from '../i18n';

/** AI javob yozayotganini bildiruvchi uch nuqta. */
export const AiTypingIndicator: FC = () => (
  <div
    className="row"
    style={{ gap: 5, height: 20, padding: '0 4px' }}
    role="status"
    aria-label={t('AI javob yozmoqda')}
  >
    {[0, 1, 2].map((i) => (
      <motion.span
        key={i}
        animate={{ y: [-3, 3, -3] }}
        transition={{
          duration: 0.8,
          repeat: Infinity,
          delay: i * 0.15,
          ease: 'easeInOut',
        }}
        style={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          backgroundColor: 'var(--accent)',
        }}
      />
    ))}
  </div>
);
